import angular from 'angular'
import { AppCtrl } from './app.controller'

// @ts-ignore
angular.module('app').controller('AppCtrl', AppCtrl)
